import React, { CSSProperties } from 'react';
import BootstrapTable from 'react-bootstrap/Table';

import TableHead from './Head';
import TableRow from './Row';
import TableCell from './Cell';
import EditableTableCell from './EditableCell';

interface TableProps {
  style?: CSSProperties;
  children: React.ReactNode[];
}

const Table = ({ style, children }: TableProps) => (
  <BootstrapTable style={style} striped>
    {children}
  </BootstrapTable>
);

Table.defaultProps = {
  style: {},
};

Table.Header = TableHead;
Table.Row = TableRow;
Table.Cell = TableCell;
Table.EditableCell = EditableTableCell;

export default Table;
